import { Box, VStack } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Routes, Route } from "react-router";
import { useParams } from "react-router-dom";
import { BannerWithHeading } from "../../../generic/layout/bannerWithHeading";
import { MaxWidthContainer } from "../../../generic/layout/maxWidthContainer";
import { PageNotFound } from "../../pageNotFound";
import { EventApprove } from "./eventApprove";
import { EventCancel } from "./eventCancel";
import { EventDetails } from "./eventDetails";
import { EventList } from "./eventList";
import { useEffect, useState } from "react";

export function EventComponent() {
  return (
    <Routes>
      <Route index element={<EventContent />} />
      <Route
        path="approve/:validationId"
        element={
          <EventContainer>
            <EventApprove />
          </EventContainer>
        }
      />
      <Route
        path="cancel/:validationId"
        element={
          <EventContainer>
            <EventCancel />
          </EventContainer>
        }
      />
      <Route
        path=":eventId"
        element={
          <EventContainer>
            <EventDetails />
          </EventContainer>
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

function EventContainer({ children }: { children: JSX.Element }) {
  const { t } = useTranslation();
  let { eventId } = useParams<{ eventId: string }>();
  const ratio =
    useBreakpointValue({ base: 180, md: 100 }, { ssr: false }) || 100;
  return (
    <VStack spacing={0}>
      <BannerWithHeading
        bgUrl={"/media/bg5_flipped.jpg"}
        headingText={t("events")}
        ratioProp={ratio}
      />

      <Box py={8} w={"100%"}>
        <MaxWidthContainer>{children}</MaxWidthContainer>
      </Box>
    </VStack>
  );
}

export function EventContent() {
  return (
    <EventContainer>
      <EventList />
    </EventContainer>
  );
}
function useBreakpointValue<T>(
  values: { base: T; md: T },
  options: { ssr: boolean }
): T | undefined {
  const [value, setValue] = useState<T | undefined>(
    options.ssr ? values.base : undefined
  );

  useEffect(() => {
    function updateValue() {
      const width = window.innerWidth;
      if (width >= 768) {
        setValue(values.md);
      } else {
        setValue(values.base);
      }
    }

    updateValue();

    window.addEventListener("resize", updateValue);
    return () => window.removeEventListener("resize", updateValue);
  }, [values]);

  return value;
}
